<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Max Cutcliffe grew up in Hobart, Tasmania, with his mother (the Bruny Island Girl); his father, Cecil; three brothers; and a sister. He frequently chatted with his mother’s mother, Louisa, who also lived in Hobart. In his youth, he frequently journeyed back and forth to Bruny Island and stayed with his ageing Uncle Joe at Clifton, where his mother was born and lived until she married Cecil. Years later, from his many notes and from family knowledge, he put together a manuscript that he called <em>Bruny Island Girl</em>. He wanted to preserve the history of this pioneering family from England, even though they had now all passed on. In recent times, his partner, Cath Morris Williams, read his manuscript and suggested that he should try and have it published. And so he did. Cath’s help in editing the manuscript is greatly appreciated.</p>
<p>Max Cutcliffe’s mother was a quiet lady, so it is hoped she approves her son’s actions and is happy to have her name, and that of her English pioneering family, live on for many years to come through this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0e49267a